export enum RoomType {
  single = 'single',
  shared = 'shared',
}
